import { BeneficiaryCreateRequestDto } from './../../core/model/beneficiary/beneficiary-create.dto';
import { BeneficiaryDocumentTypeResponseDto } from './../../core/model/beneficiary/beneficiary-document-type.dto';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BeneficiaryAccountTypeResponseDto } from '@app/core/model/beneficiary/beneficiary-account-type.dto';
import { BeneficiaryBankResponseDto } from '@app/core/model/beneficiary/beneficiary-bank.dto';
import { BeneficiaryService } from '@app/core/services/beneficiary.service';
import { MaterialModuleModule } from '@app/shared/material-module/material-module.module';
import { SharedModule } from '@app/shared/shared.module';
import { NotificationToastrService } from '@app/shared/services/notification-toastr.service';
import Swal from 'sweetalert2';
import { UploadInfoExceptionalBeneficiaryComponent } from './upload-info-exceptional-beneficiary/upload-info-exceptional-beneficiary.component';
import { SpkPopoversComponent } from 'src/app/shared/components/@spk/reusable-ui-elements/spk-popovers/spk-popovers.component';
import { NgbModal, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { getDocumentValidators } from '@app/shared/validators';
import { CheckExceptionalBeneficiaryComponent } from './check-exceptional-beneficiary/check-exceptional-beneficiary.component';
import { CreatedChannel } from '@app/shared/enum/created-channel.enum';
// Ensure the correct path for the SpkPopoversComponent import
@Component({
  selector: 'app-upload-users',
  standalone: true,
  imports: [SharedModule, RouterModule, MaterialModuleModule, SpkPopoversComponent, NgbPopoverModule, UploadInfoExceptionalBeneficiaryComponent],
  templateUrl: './upload-users.component.html',
  styleUrl: './upload-users.component.scss'
})
export class UploadUsersComponent {

  private _beneficiaryService = inject(BeneficiaryService);
  private _notificationToastrService = inject(NotificationToastrService);
  formUploadUsers: FormGroup;
  documentTypes: BeneficiaryDocumentTypeResponseDto[] = [];
  banks: BeneficiaryBankResponseDto[] = [];
  bankAccountTypes: BeneficiaryAccountTypeResponseDto[] = [];
  isExceptionalBeneficiary: boolean = false;
  originalForm: boolean = false;
  public currentDocType: string | null = null;


  constructor(private fb: FormBuilder, private sanitizer: DomSanitizer, private serviceModal: NgbModal,) {
    this.formUploadUsers = this.fb.group({
      documentType: [null, Validators.required],
      documentNumber: ['', Validators.required],
      name: ['', Validators.required],
      lastname: ['', Validators.required],
      maternalLastname:['', Validators.required],
      email: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-ñÑ]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
      cci: ['', [Validators.required, Validators.pattern(/^\d{20}$/)]],
      bankName: [null, Validators.required],
      accountType: [null, Validators.required],
    })
  }

  ngOnInit(): void {

    this.callModal();
  }

  callModal(): void {
    Swal.fire({
          title: 'Importante',
          text: 'Asegurate que la cuenta CCI que ingresaste este a tu nombre. Es decir tu seas el titular de esta cuenta. De lo contrario no recibirás los abonos.',
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar'
          }).then((result) => {
            if(result.isConfirmed){
              this.checkIfUserIsExceptional();
            }
          })
  }

  dataForExceptionalForm: {
    dni: string, documentType: any
  } | null = null;

  checkIfUserIsExceptional(): void{
    const modalRef = this.serviceModal.open(CheckExceptionalBeneficiaryComponent, {backdrop: 'static', centered: true, size: 'xl', keyboard: false})
    modalRef.result.then((result) => {
      if(result){
        this.chargeInformationRequired();

        this.isExceptionalBeneficiary = result.isExceptional;
        this.originalForm = !result.isExceptional;

        console.log(result.documentType);


        // Si el usuario es excepcional, guarda los datos para pasarlos al hijo.
        if (this.isExceptionalBeneficiary && result.dni && result.documentType) {
          this.dataForExceptionalForm = {
            dni: result.dni,
            documentType: result.documentType
          };
        }

        else if (this.originalForm && result.dni && result.documentType) {
            this._beneficiaryService.getDocumentTypes().subscribe(resp => {
            this.documentTypes = resp.data;

            const matchingDocType = this.documentTypes.find(dt => dt.id === result.documentType.id);

            this.formUploadUsers.patchValue({
              documentNumber: result.dni,
              documentType: matchingDocType || null
            });

            this.formUploadUsers.get('documentNumber')?.disable();
            this.formUploadUsers.get('documentType')?.disable();

            this.addDocumentValidatorsByDocumentType(); // importante llamar después para reactivar validadores
          });
        }
      }
    })
  }

  chargeInformationRequired(): void {
    this._beneficiaryService.getDocumentTypes().subscribe(resp => {
      this.documentTypes = resp.data;
    })

    this._beneficiaryService.getBanks().subscribe(resp => {
      this.banks = resp.data;
    })

    this._beneficiaryService.getBankAccountTypes().subscribe(resp => {
      this.bankAccountTypes = resp.data;
    })

    this.addDocumentValidatorsByDocumentType();
  }

  addDocumentValidatorsByDocumentType(): void {
    this.formUploadUsers.get('documentType')?.valueChanges.subscribe((docType: BeneficiaryDocumentTypeResponseDto) => {
      const docNumberControl = this.formUploadUsers.get('documentNumber');

      if (!docNumberControl) return;

      docNumberControl.clearValidators();

      if (docType?.type) {
        docNumberControl.setValidators(getDocumentValidators(docType.type));
      }

      docNumberControl.updateValueAndValidity();
    });
  }

    validateDocNumberInput(event: KeyboardEvent): boolean {
      const key = event.key;

      if (this.currentDocType === 'DNI' || this.currentDocType === 'RUC') {
        const isNumber = /^[0-9]$/.test(key);
        if (!isNumber) {
          event.preventDefault();
          return false;
        }
      }

      if (this.currentDocType === 'PAS' || this.currentDocType === 'CE') {
        const isAlphanumeric = /^[a-zA-Z0-9]$/.test(key);
        if (!isAlphanumeric) {
          event.preventDefault();
          return false;
        }
      }

      return true;
    }

  sendUploadUserInformation() {
    Swal.fire({
      title: '¿Estás seguro?',
			text: 'Asegurate que la cuenta CCI que ingresaste este a tu nombre . Es decir tu seas el titular de esta cuenta . De lo contrario no recibirás los abonos.',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Enviar Informacion',
			cancelButtonText: 'Cancelar'
    }).then((result) => {

      if(result.isConfirmed){
        const formData = this.formUploadUsers.getRawValue();

        if (this.formUploadUsers.invalid) {
          this._notificationToastrService.error("Debe registrar los campos obligatorios");
          return;
        }

        const requestCreateDto: BeneficiaryCreateRequestDto = {
          documentTypeId: formData.documentType?.id,
          documentNumber: formData.documentNumber,
          name: formData.name,
          lastname: formData.lastname,
          maternalLastname: formData.maternalLastname,
          email: formData.email,
          bankTypeId: formData.bankName,
          bankAccountTypeId: formData.accountType,
          cci: formData.cci,
          createdChannel: CreatedChannel.PRESENCIAL
        };

        console.log(`Beneficiary request ${requestCreateDto.documentTypeId}`);


        this._beneficiaryService.createBeneficiary(requestCreateDto).subscribe({
          next: resp => {

            this._notificationToastrService.success("¡Se enviaron los datos correctamente!")
            this.formUploadUsers.reset();
            this.originalForm = false;
            this.callModal();
          },
          error: error => {
            const message = error?.error?.status?.message || 'Ocurrió un error al enviar los datos';
            Swal.fire({
              title: 'Registro no autorizado',
              text: message,
              icon: 'warning',
              confirmButtonText: 'Cancelar'
            });
          }
        });
      }

    }, (error) => {
      console.error(error);
    })

  }

  SvgPopover = [
    { id: 2,
      class:'popover-secondary only-body',
      content: "Asegurate que la cuenta CCI que ingresaste este a tu nombre. Es decir tu seas el titular de esta cuenta. De lo contrario no recibirás los abonos.",
      svg: `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>`,
      color: "me-4 svg-secondary",
      textcolor: ''
    },
  ]

  getSanitizedSVG(svgContent: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(svgContent);
  }

  onInfoSentSuccess(): void {
    this.isExceptionalBeneficiary = false;
    this.dataForExceptionalForm = null;
    this.callModal();
  }

}
